import { endOfDay, startOfDay, subDays } from 'date-fns'

export type EventAnalyticsPreset = '7d' | '30d' | '90d'

export function presetToDays(preset: EventAnalyticsPreset): number {
  switch (preset) {
    case '7d':
      return 7
    case '30d':
      return 30
    case '90d':
      return 90
  }
}

export function rangeFromPreset(preset: EventAnalyticsPreset): {
  from: string
  to: string
} {
  const to = endOfDay(new Date())
  const from = startOfDay(subDays(to, presetToDays(preset) - 1))
  return {
    from: from.toISOString(),
    to: to.toISOString()
  }
}

/** Same length window immediately before the current preset range. */
export function previousRangeFromPreset(preset: EventAnalyticsPreset): {
  from: string
  to: string
} {
  const days = presetToDays(preset)
  const current = rangeFromPreset(preset)
  const currentStart = new Date(current.from)
  const previousEnd = endOfDay(subDays(currentStart, 1))
  const previousStart = startOfDay(subDays(previousEnd, days - 1))
  return {
    from: previousStart.toISOString(),
    to: previousEnd.toISOString()
  }
}
